import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { FormControl, FormGroup, FormArray, UntypedFormBuilder, FormBuilder, ReactiveFormsModule } from '@angular/forms';

class TypedFormControl extends FormControl {
    constructor(formState = null, validatorOrOpts, asyncValidator) {
        super(formState, validatorOrOpts, asyncValidator);
    }
    setValue(value, options) {
        super.setValue(value, options);
    }
    patchValue(value, options = {}) {
        super.patchValue(value, options);
    }
    reset(formState = null, options = {}) {
        super.reset(formState, options);
    }
}
class TypedFormGroup extends FormGroup {
    constructor(controls, options, asyncValidator) {
        super(controls, options, asyncValidator);
    }
    setValue(value, options = {}) {
        super.setValue(value, options);
    }
    patchValue(value, options = {}) {
        super.patchValue(value, options);
    }
    reset(value = {}, options = {}) {
        super.reset(value, options);
    }
    getRawValue() {
        return super.getRawValue();
    }
}
class TypedFormArray extends FormArray {
    constructor(controls, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
    }
    setValue(value, options) {
        super.setValue(value, options);
    }
    patchValue(value, options = {}) {
        super.patchValue(value, options);
    }
    getRawValue() {
        return super.getRawValue();
    }
}

class TypedFormBuilder extends UntypedFormBuilder {
    constructor() {
        super();
        this._fb = new FormBuilder();
        this._fb.control = this.control;
    }
    group(controlsConfig, options) {
        const { controls, updateOn, validator, asyncValidator } = this._fb.group(controlsConfig, options);
        return new TypedFormGroup(controls, {
            asyncValidators: asyncValidator,
            validators: validator,
            updateOn,
        });
    }
    control(formState, validatorOrOpts, asyncValidator) {
        return new TypedFormControl(formState, validatorOrOpts, asyncValidator);
    }
    array(controlsConfig, validatorOrOpts, asyncValidator) {
        const ctrl = this._fb.array(controlsConfig, validatorOrOpts, asyncValidator);
        return new TypedFormArray(ctrl.controls, {
            asyncValidators: ctrl.asyncValidator,
            updateOn: ctrl.updateOn,
            validators: ctrl.validator,
        });
    }
}
TypedFormBuilder.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TypedFormBuilder, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
TypedFormBuilder.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TypedFormBuilder });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TypedFormBuilder, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

class TypedReactiveFormsModule {
}
TypedReactiveFormsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TypedReactiveFormsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TypedReactiveFormsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: TypedReactiveFormsModule, imports: [ReactiveFormsModule], exports: [ReactiveFormsModule] });
TypedReactiveFormsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TypedReactiveFormsModule, providers: [TypedFormBuilder], imports: [ReactiveFormsModule, ReactiveFormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TypedReactiveFormsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [ReactiveFormsModule],
                    exports: [ReactiveFormsModule],
                    providers: [TypedFormBuilder],
                }]
        }] });

/*
 * Public API Surface of formsafe
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TypedFormArray, TypedFormBuilder, TypedFormControl, TypedFormGroup, TypedReactiveFormsModule };
